export enum AmountTypeEnum {
  SenderAmount = 'SenderAmount',
  BeneficiaryAmount = 'BeneficiaryAmount',
}
